import {ISettingsGetter} from '@wix/tpa-settings'
import {LIST_DISPLAY_STRATEGY} from '@wix/wix-events-commons-statics'
import settingsParams from '../../components/widget/settingsParams'
import {ALL_CATEGORIES_FILTER} from '../constants/settings'
import {CategoryWithSelection, decodeCategoryState} from '../utils/settings'

const getCategoriesWithSelection = (getSetting: ISettingsGetter): CategoryWithSelection[] => {
  const encodedIds = getSetting(settingsParams.selectedCategoryIds) as string

  if (!encodedIds) {
    return [{guid: ALL_CATEGORIES_FILTER, selected: true}]
  }

  const categories = (encodedIds.match(/.{20}/g) || []).map(encodedGuid => decodeCategoryState(encodedGuid))

  return categories.length ? categories : [{guid: ALL_CATEGORIES_FILTER, selected: true}]
}

export const getSelectedCategoryIds = (getSetting: ISettingsGetter): string[] => {
  const categories = getCategoriesWithSelection(getSetting)
  const selectedCategories = categories.filter(category => category.selected).map(category => category.guid)
  return selectedCategories.length ? selectedCategories : [ALL_CATEGORIES_FILTER]
}

export const getCategoryOrderIds = (getSetting: ISettingsGetter): string[] => {
  const categories = getCategoriesWithSelection(getSetting)
  return categories.map(category => category.guid)
}

export const getInitialCategoryId = (getSetting: ISettingsGetter): string => {
  const initialCategoryId = getSetting(settingsParams.initialCategoryId) as string
  const defaultCategoryId = initialCategoryId || ALL_CATEGORIES_FILTER
  const selectedCategoryIds = getSelectedCategoryIds(getSetting)

  if (selectedCategoryIds.includes(defaultCategoryId)) {
    return defaultCategoryId
  }

  return selectedCategoryIds[0] || ALL_CATEGORIES_FILTER
}

export const isCategoryMenuMode = (getSetting: ISettingsGetter): boolean => {
  const listDisplayStrategy = getSetting(settingsParams.listDisplayStrategy) as LIST_DISPLAY_STRATEGY
  const showCategoryMenu = getSetting(settingsParams.showCategoryMenu) as boolean
  const selectedCategoryIds = getSelectedCategoryIds(getSetting)

  return (
    listDisplayStrategy === LIST_DISPLAY_STRATEGY.MULTIPLE_CATEGORIES &&
    showCategoryMenu &&
    Boolean(selectedCategoryIds.length)
  )
}

export const getNullableCategoryId = (id: string): string | null => (id === ALL_CATEGORIES_FILTER ? null : id)
